import script from "./HabilitiesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HabilitiesSection.vue?vue&type=script&setup=true&lang=ts"

import "./HabilitiesSection.vue?vue&type=style&index=0&id=87fea5b4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87fea5b4"]])

export default __exports__